module.exports = __webpack_public_path__ + "static/media/l_itdot_13.a0621d7d.png";